(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'react-icons/fa6', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-icons/fa6'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.fa6, global.propTypes);
    global.GroupTitle = mod.exports;
  }
})(this, function (exports, _react, _fa, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var GroupTitle = function (_React$Component) {
    _inherits(GroupTitle, _React$Component);

    function GroupTitle() {
      _classCallCheck(this, GroupTitle);

      return _possibleConstructorReturn(this, (GroupTitle.__proto__ || Object.getPrototypeOf(GroupTitle)).apply(this, arguments));
    }

    _createClass(GroupTitle, [{
      key: 'render',
      value: function render() {
        var titleStyles = {
          display: 'block',
          fontSize: this.props.isMobile ? '18px' : '15px',
          lineHeight: this.props.isMobile ? 'initial' : '75px',
          letterSpacing: this.props.isMobile ? '1.7px' : '0',
          fontWeight: '300',
          margin: this.props.isMobile ? '5px 0 0' : 0,
          color: this.props.listOpen && this.props.isMobile ? '#fff' : 'inherit',
          transition: this.props.isMobile ? 'all 0.25s ease-in-out' : '0s',
          cursor: 'pointer'
        };
        var caretUp = _react2.default.createElement(_fa.FaAngleUp, { size: 20, className: 'caret-up', style: { margin: '0 0 5px 5px', float: 'right' } });
        var caretDown = _react2.default.createElement(_fa.FaAngleDown, { size: 20, className: 'caret-down', style: { margin: '0 0 5px 5px', float: 'right' } });
        var arrowStyle = {
          caret: this.props.listOpen ? caretUp : caretDown
        };

        var mobileTitleStyles = {
          width: '60%',
          paddingTop: '10px'
        };

        var padd = this.props.isMobile ? this.props.listOpen ? '10px 15px' : '6px 15px' : '0 25px 0 10px';
        titleStyles.padding = padd;

        if (this.props.href) {
          return _react2.default.createElement(
            'a',
            {
              href: encodeURI(this.props.href),
              className: 'group-list-title' + (this.props.isMobile ? ' text-left' : '') + (this.props.className ? this.props.className : ''),
              style: titleStyles
            },
            this.props.title
          );
        }

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            {
              style: titleStyles,
              className: 'group-list-title' + (this.props.isMobile ? ' text-left' : '') + (this.props.className ? this.props.className : '') + ' list-open-' + this.props.listOpen,
              onClick: this.props.toggleOpen,
              id: '' + this.props.title
            },
            this.props.title,
            this.props.isMobile ? arrowStyle.caret : null,
            _react2.default.createElement('span', { style: this.props.isMobile ? mobileTitleStyles : null })
          ),
          this.props.listOpen && this.props.isMobile ? _react2.default.createElement('div', { className: 'menu-item-border', style: {
              marginTop: '-3px',
              borderBottom: '3px solid #f0ab00',
              width: '90%',
              margin: '-3px 0 0 14px',
              cursor: 'pointer'
            } }) : _react2.default.createElement('div', { className: 'menu-item-border' })
        );
      }
    }]);

    return GroupTitle;
  }(_react2.default.Component);

  exports.default = GroupTitle;


  GroupTitle.propTypes = {
    title: _propTypes2.default.string,
    href: _propTypes2.default.string,
    className: _propTypes2.default.string,
    toggleOpen: _propTypes2.default.func,
    listOpen: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool
  };
});